import React, { useEffect } from "react";
import "../../../assets/styles/pages/homeCss/PlateFrom.css";
import { Col, Container, Row } from "react-bootstrap";
import laptop from "../../../assets/images/homeImages/Apple-Macbook-Gold2.png";

import AOS from 'aos'
import { Link } from "react-router-dom";

const PlateFrom = () => {

  useEffect(()=>{
    AOS.init({duration:2000, } , );
   },[])

  return (
    <section className="plateFrom">
      <Container >
        <Row className="">
          <Col md={6} lg={6} data-aos='fade-left'>
            <div className=" plateFrom-texts-div">
              <div className="plateFroms-center-item">
                <h1 className=" plateFrom-h1">
                  One Platform All Areas Of Wellbeing
                </h1>
                <p className="plateFrom_p">
                  Empowering employee wellbeing <br/>through data, insight and action
                </p>
                <div className="d-flex">
                  {/* <button type="button" className="hero-button-demo plateFroms-request-btn mt-3">
                    Request a demo
                  </button> */}
                  <Link to="https://calendly.com/oxyzn/meeting-with-oxyzn" target="_blank" className="hero-button-demo plateFroms-request-btn mt-3">
                    Request a demo
                  </Link>
                  <button className="hero-button mt-3 plateFroms-learn-btn">Learn More</button>
                </div>
              </div>
            </div>
          </Col>
          <Col md={6} lg={6} data-aos='fade-right'>
            <div className="plateFrom-cont-img ">
              <img src={laptop} alt="" />
            </div>
          </Col>
        </Row>
      </Container>
      <Container fluid>
    
        <div className="whatOxi " data-aos='fade-up'>
          <p className="whatOxi-head">How it Works</p>
          <div className="whatOxi-p">
            <p>
              Getting started is easy — we remove the guesswork with a personal
              assessment and algorithm to match employees with the right Coach,
              and keep them engaged throughout their growth journey
            </p>
          </div>

          <div className="whatOxi-img-main " data-aos='fade-up'>
            <iframe
              className="text-center whatOxi-img"
              width="1300"
              height="715"
              src="https://www.youtube.com/embed/lKqhfhD91Gw"
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default PlateFrom;
